const TAB_SESSION_STORAGE_KEY = 'owner_console_tab_session_id'

export const getOwnerTabSessionId = (): string => {
  if (typeof window === 'undefined') return 'server-session'
  try {
    let id = window.sessionStorage.getItem(TAB_SESSION_STORAGE_KEY)
    if (!id) {
      id = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : `owner-tab-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 9)}`
      window.sessionStorage.setItem(TAB_SESSION_STORAGE_KEY, id)
    }
    return id
  } catch {
    return 'transient-owner-session'
  }
}
